
import React from 'react';

import { toast } from 'react-toastify';
import axios from 'axios';
import { Button } from 'antd';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import strings from '../../components/Language';

import _ from 'lodash';
import moment from 'moment';
import SubLayout from '../../components/Layout/SubLayout';
import LoaderContext from '../../components/Loader/LoaderContext.js';

class AIOrders extends React.Component {
	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			data: [],
			next_page_url: null,
			startDate: null,
			endDate: null,
			is_loading_first: true,
		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			setTimeout(() => {
				this.setState({ access_token: token });
				this.getData(api.ai_order_report);
			});
		}
	}

	getData(API, is_next_page = false) {
		const { setLoading } = this.context;
		if (API === undefined || API === null || API === "" && !this.state.is_load) {
			return true;
		}
		if (this.state.startDate && this.state.endDate) {
			if (is_next_page) {
				API = API + "&start_date=" + (this.state.startDate ? moment(this.state.startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.endDate ? moment(this.state.endDate).format("YYYY-MM-DD") : "");
			} else {
				API = API + "?start_date=" + (this.state.startDate ? moment(this.state.startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.endDate ? moment(this.state.endDate).format("YYYY-MM-DD") : "");
			}
		}
		var self = this;
		if (self.state.access_token) {
			setLoading(true);
			axios({
				method: 'GET',
				url: API,
				headers: {
					'Authorization': 'Bearer ' + self.state.access_token,
					'Content-Type': 'application/json',
					'Accept-Language': strings.getLanguage(),
				}
			}).then(function (ress) {
				if (ress.data && ress.data.error === 200) {
					self.setState({
						data: (ress.data.data && ress.data.data.data) ? [...self.state.data, ...ress.data.data.data] : self.state.data,
						next_page_url: (ress.data.data && ress.data.data.next_page_url) ? ress.data.data.next_page_url : null,
					});
				} else {
					if (ress.data.validation && ress.data.validation.length !== 0) {
						_.forEach(ress.data.validation, function (value) {
							if (value[0]) {
								toast.error(value[0]);
							}
						});
					} else {
						toast.error(ress.data.message);
					}
				}
				setTimeout(() => {
					self.setState({ is_loading_first: false });
				});
				setLoading(false);
			}).catch(function (e) {
				setLoading(false);
			});
		}
	};


	handleChange = (dates) => {
		const [start, end] = dates;
		this.setState({ startDate: start, endDate: end });

		if (this.props.onChange) {
			this.props.onChange({ startDate: start, endDate: end });
		}
		setTimeout(() => {
			if (start && end) {
				this.getData(api.ai_order_report);
			}
		});
	};

	render() {
		const { startDate, endDate } = this.state;
		return (
			<>
				<div style={{ margin: 10, marginTop: 20 }}>
					<div className='api_list_back_wallet'>
						<DatePicker
							selected={startDate}
							onChange={this.handleChange}
							startDate={startDate}
							endDate={endDate}
							selectsRange
							isClearable
							className="form-control text_box datepicker-input"
							placeholderText="Select a date range"
						/>
					</div>
				</div>

				{
					this.state.data.length > 0 ?
						null
						:
						<h5 className='text-center text-danger mt-2'>{this.state.is_loading_first ? strings.loading : strings.no_logs}</h5>
				}
				{this.state.data.map((item, i) =>
					<div key={i + 100} className="list_item">
						<div className="row">
							<div className='col-6'>
								<div className='width-auto margin-left-1'>
									<span className=''>{(item.data && item.data.symbol) ? item.data.symbol : ''}</span>
								</div>
							</div>
							<div className='col-6 avg_label'>
								<div className='width-auto'>
									<label className=''>{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}</label>
								</div>
							</div>
						</div>
						<div className="row">
							<div className='col-6'>
								<div className='width-auto margin-left-1'>
									<span className={(item.data && item.data.side && item.data.side == 'sell') ? 'text_down' : 'text_up'} style={{ textTransform: "uppercase" }}>{strings.market}{"/"}{(item.data && item.data.side) ? item.data.side : '-'}</span>
								</div>
							</div>
							<div className='col-6 avg_label'>
								<div className='width-auto'>
									<span className='text_up'>{(item.data && item.data.status) ? item.data.status : '-'}</span>
								</div>
							</div>
						</div>
						<div className="row list_details">
							<div className='col-6 gray_color'>
								<div className='width-auto margin-left-1'>
									<span className=''>{strings.amount}</span>
								</div>
							</div>
							<div className='col-6 avg_label'>
								<div className='width-auto'>
									<span className=''>
										{
											(item.data && item.data.fee && item.data.fee.currency && item.data.fee.currency !== "BNB") ? Number.parseFloat(item.data.amount - item.data.fee.cost).toFixed(5) : Number.parseFloat(item.data.amount).toFixed(5)
										}
									</span>
								</div>
							</div>
						</div>
						<div className="row list_details">
							<div className='col-6 gray_color'>
								<div className='width-auto margin-left-1'>
									<span className=''>{strings.price}</span>
								</div>
							</div>
							<div className='col-6 avg_label'>
								<div className='width-auto'>
									<span className=''>{(item.data && item.data.price) ? Number.parseFloat(item.data.price).toFixed(5) : '0.00'}</span>
								</div>
							</div>
						</div>
						<div className="row list_details">
							<div className='col-6 gray_color'>
								<div className='width-auto margin-left-1'>
									<span className=''>{strings.fee}{' '} {(item.data && item.data.fee && item.data.fee.currency) ? "(" + item.data.fee.currency + ")" : ''}</span>
								</div>
							</div>
							<div className='col-6 avg_label'>
								<div className='width-auto'>
									<span className=''>{(item.data && item.data.fee && item.data.fee.cost) ? Number.parseFloat(item.data.fee.cost).toFixed(10) : '0.00'}</span>
								</div>
							</div>
						</div>
						<div className="row list_details">
							<div className='col-6 gray_color'>
								<div className='width-auto margin-left-1'>
									<span className=''>{strings.total}{' '}</span>
								</div>
							</div>
							<div className='col-6 avg_label'>
								<div className='width-auto'>
									<span className=''>{(item.data && item.data.cost) ? Number.parseFloat(item.data.cost).toFixed(10) : '0.00'}</span>
								</div>
							</div>
						</div>
					</div>
				)}

				{this.state.next_page_url ?
					<div className='flex-center' style={{ justifyContent: "center" }}>
						<Button onClick={() => this.getData(this.state.next_page_url, true)} type="primary" className='btn rounded-sm btn-m text-uppercase font-700 mt-4 mb-3 btn-full '
							style={{ fontSize: 14, paddingBlock: 10, background: '#446CE3', color: "#FFF", borderRadius: 10 }}>
							{strings.Load_More}
						</Button>
					</div>
					: null}
			</>
		);
	}
}
export default AIOrders;
